import type { ReactNode } from 'react';
import AddIcon from '@mui/icons-material/Add';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { Box, Card, CardActionArea, Typography } from '@mui/material';

interface ProfileItemProps {
  children?: ReactNode;
  title: string;
  onClick: () => void;
}

export const ProfileItem = ({ children, title, onClick }: ProfileItemProps) => {
  const empty = !children;

  return (
    <Card
      variant="outlined"
      sx={(theme) => ({
        ...(empty && {
          backgroundColor: theme.palette.secondary.light,
          borderColor: theme.palette.secondary.dark,
        }),
      })}
    >
      <CardActionArea onClick={onClick}>
        <Box
          alignItems="center"
          display="flex"
          flexDirection="row"
          p={2}
          width="100%"
        >
          <Box flex={1}>
            <Typography component="p" sx={{ mb: children ? 1 : undefined }}>
              {title}
            </Typography>
            {children}
          </Box>
          <Box>
            {empty ? (
              <AddIcon fontSize="small" />
            ) : (
              <ChevronRightRoundedIcon fontSize="small" />
            )}
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  );
};
